import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-button-padrao',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    NgClass
  ],
  templateUrl: './button-padrao.component.html',
  styleUrl: './button-padrao.component.css'
})
export class ButtonPadraoComponent {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() iconSrc?: string;
  @Input() iconSrcExtensao?: string;
  @Input() classIcon?: string;

  @Input() backgroundColor?: string;
  @Input() color?: string;
  @Input() borderColor?: string;
  @Input() boxShadow?: string;

  @Input() width?: string;
  @Input() height?: string;
  @Input() widthIcon?: string;
  @Input() heightIcon?: string;
  @Input() fontSize?: string;
  @Input() fontWeight?: string;
  @Input() letterSpacing?: string;

  @Input() borderWidth?: string;
  @Input() borderStyle?: string;
  @Input() borderRadius?: string;

  @Input() borderRightWidth?: string;
  @Input() borderRightStyle?: string;

  @Input() padding?: string = '0px';

  @Input() type = 'button';
  @Input() disabled = false;

  @Output() buttonClick = new EventEmitter<void>();

  acaoClick() { this.buttonClick.emit(); }
}
